/**
 * Formatters and validators shared by the browser and the Worker.
 *
 * `isValidPhone` is lifted verbatim from the NLC platform on purpose: every Tekavra
 * lead form validates phone numbers the same way, so a number that is accepted on one
 * site is accepted on all of them.
 */

export function formatCurrency(amount: number, locale = 'en-US'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(amount);
}

/** Two-decimal money, for per-visit figures where the cents matter. */
export function formatCurrencyExact(amount: number, locale = 'en-US'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function formatPhone(phone: string): string {
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

export function isValidPhone(phone: string): boolean {
  const cleaned = phone.replace(/\D/g, '');
  // A usable US number is 10 digits, or 11 with a leading country-code 1.
  return cleaned.length === 10 || (cleaned.length === 11 && cleaned.startsWith('1'));
}

/** Loose on purpose — the phone number is the field we actually need. */
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim());
}

export function formatSqft(sqft: number, locale = 'en-US'): string {
  return new Intl.NumberFormat(locale).format(Math.round(sqft));
}
